// RelapsePreventionCard — Today Tools-drawer harm-reduction surface
// (PR 2C, Gap 9).
//
// Framed as preparation, not permission. Three quick KB deep-links plus
// an optional "set my state" CTA so future renders surface a state-
// specific naloxone locator. Collapsible default-closed: this content
// is important but not first-glance.
//
// Mobile discipline:
//  - <details> default-closed; chevron rotates on open.
//  - 3 KB links render as ListItemCard rows (existing component) for
//    visual consistency with the rest of Tools.
//  - No images, no big block of text — every link is one-tap into a
//    knowledge entry that has the full content.

import { ChevronDown, ShieldCheck, Phone, Pill } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../../components/ui/Card';
import { Icon } from '../../components/ui/Icon';
import { useAuth } from '../../auth/AuthContext';

export function RelapsePreventionCard() {
  const navigate = useNavigate();
  const { me } = useAuth();
  const state = me?.settings.state ?? '';

  return (
    <Card className="relapse-prevention-card" accentLeft>
      <details className="relapse-prevention-details">
        <summary className="relapse-prevention-summary">
          <div className="relapse-prevention-summary-text">
            <span className="relapse-prevention-eyebrow">Relapse-prevention basics</span>
            <span className="relapse-prevention-headline">If it happens, plan for it.</span>
          </div>
          <Icon icon={ChevronDown} size={18} className="relapse-prevention-chevron" />
        </summary>
        <div className="relapse-prevention-body">
          <ul className="relapse-prevention-list">
            <li>
              <a
                href="/app/knowledge/naloxone-locator"
                className="relapse-prevention-link"
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/app/knowledge/naloxone-locator');
                }}
              >
                <Icon icon={Pill} size={16} />
                <div>
                  <span className="relapse-prevention-link-title">
                    Find free naloxone near you
                  </span>
                  <span className="relapse-prevention-link-caption">
                    Mail-order, OTC, state programs. No prescription.
                  </span>
                </div>
              </a>
            </li>
            <li>
              <a
                href="/app/knowledge/good-samaritan-law-overview"
                className="relapse-prevention-link"
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/app/knowledge/good-samaritan-law-overview');
                }}
              >
                <Icon icon={ShieldCheck} size={16} />
                <div>
                  <span className="relapse-prevention-link-title">
                    Good Samaritan overdose laws
                  </span>
                  <span className="relapse-prevention-link-caption">
                    {state ? `Coverage in ${state} + national overview.` : '48 states protect the caller from arrest.'}
                  </span>
                </div>
              </a>
            </li>
            <li>
              <a
                href="/app/knowledge/harm-reduction-prep"
                className="relapse-prevention-link"
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/app/knowledge/harm-reduction-prep');
                }}
              >
                <Icon icon={Phone} size={16} />
                <div>
                  <span className="relapse-prevention-link-title">
                    Never use alone — hotline
                  </span>
                  <span className="relapse-prevention-link-caption">
                    1-800-484-3731 · stays on the line, calls 911 if you go unresponsive.
                  </span>
                </div>
              </a>
            </li>
          </ul>
          {!state ? (
            <p className="relapse-prevention-state-cta dim text-caption">
              <a href="/app/more#whys" onClick={(e) => { e.preventDefault(); navigate('/app/more'); }}>
                Set your state →
              </a>{' '}
              so we can surface state-specific links.
            </p>
          ) : null}
        </div>
      </details>
    </Card>
  );
}
